import { Page } from "components/Page";
import { Agents } from "features/agent/agent";

export const AgentPage = () => {
    return (
        <Page title="Jaman HP Gas| Agent">
            <Agents />
        </Page>
    );
};
